import { useColorModeValue } from "@chakra-ui/color-mode"

function useColorValue(value) {
  return useColorModeValue(`primary.${value}`, `dark.${value}`)
}

export default useColorValue
